import module from 'module';
import LocalCache from 'shared/util/localCache';

module.factory('translationCache', (http, CacheFactory, config) => {
    return new LocalCache({
      provider: () => {
        let lang = config.defaultLanguage;
        return http.get(`/translations?language=${lang}`)
      },
      cacheFactory: CacheFactory,
      cacheTime: config.cache.translation,
      cacheName: 'translation'
    })
  }
);

